export { default as LoyaltyPaymentMethodWidget } from './loyalty-payment-method-widget';
